import {TimbraturaRecord} from "@commons/mapping/TimbraturaLavRecord";
import {Timbratura} from "./Timbratura";

interface StrisciataTimbratureProps {
    timbrature: Pick<TimbraturaRecord, 'tsTimbratura' | 'verso' | 'rimossa' | 'manuale'>[] | undefined | null,
    title?: string,
    titleIfNull?: string,
}

export const StrisciataTimbrature: React.FC<StrisciataTimbratureProps> = ({timbrature, title, titleIfNull}) => {
    if (!timbrature || timbrature.length === 0) {
        if (titleIfNull)
            return <div className="block m-2">
                {title && <div className="text-center">{title}</div>}
                <div className="text-red-700 text-center">{titleIfNull}</div>
            </div>;
        else
            return null;
    }

    return <div className="block m-2">
        {title && <div className="text-center mb-2">{title}</div>}

        <div className="flex flex-row justify-center gap-1.5">
            {timbrature.map((timbratura, index) => {
                return <Timbratura key={index} timbratura={timbratura} scala={1.25}/>
            })}
        </div>

    </div>
}